module.exports = __webpack_public_path__ + "img/upload-white-sm.151569d4.svg";